import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { createBrowserHistory } from 'history';
import moment from 'moment';
import React from 'react';
import { isMobile } from 'react-device-detect';
import ReactDOM from 'react-dom';

import MobilePage from 'components/MobilePage';
import { env } from 'config';
import App from './App';
import PublicApp from './PublicApp';
import { isPublicRoute } from './publicRoutes';
import { loadPulse } from './pulse';
import './assets/scss/index.scss';
import * as serviceWorker from './serviceWorker';
import './styles.scss';

moment.locale('ru');

const history = createBrowserHistory();

Sentry.init({
  dsn: env.SENTRY_DSN,
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
    }),
  ],
  tracesSampleRate: Number(env.SENTRY_TRACES_SAMPLE_RATE),
  environment: env.APP_ENV,
});

loadPulse();

const renderRoot = () => {
  // Публичные страницы рендерятся отдельным минимальным деревом: без авторизации,
  // глобальных виджетов и мобильной заглушки — их открывают в том числе с телефона
  if (isPublicRoute(globalThis.location.pathname)) return <PublicApp />;

  if (isMobile) return <MobilePage />;

  return <App />;
};

ReactDOM.render(renderRoot(), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
